import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [],
});
